import React from "react";
import { message } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { EntityStatus } from "../../Constants/Constants";
import ListServiceEntitlement from "./ListServiceEntitlement";
import ServiceEntitlementForm from "./ServiceEntitlementForm";
import { apiCallback, statusChangeApiCallback } from "../../ApiHandlers/Common";
import { convertServiceEntitlementList } from "../../Helpers/ServiceEntitlementHelpers";

class ServiceEntitlement extends React.Component {
  constructor(props) {
    super(props);
    this.header = [...(props.parentBread || []), "Service Entitlement"];
    this.state = {
      action: null,
      record: null,
      serviceEntitlementData: [],
      serviceEntitlementDataLoading: false,
    };
    console.log("ServiceEntitlement props", props);
  }

  componentDidMount() {
    this.updateServiceEntitlementList();
  }

  updateServiceEntitlementList() {
    console.log("updateDataList...");
    const { history, serviceEntitlementApi, serviceProviderRecord } =
      this.props;
    this.setState({ serviceEntitlementDataLoading: true });
    const errorCallback = (error) => {
      this.setState({ serviceEntitlementDataLoading: false });
      message.error("Error fetching Service Entitlement list");
    };
    const successCallback = (data) => {
      const serviceEntitlementData = convertServiceEntitlementList(data);
      console.log("updateDataList data", serviceEntitlementData);
      this.setState({
        serviceEntitlementData,
        serviceEntitlementDataLoading: false,
      });
    };
    try {
      serviceEntitlementApi.getAllEntitlementByProvider(
        serviceProviderRecord.providerId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  }

  onActionClick = (action, record) => () => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateServiceEntitlementList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    try {
      console.log("onStatusChange", status, record);
      const { entitlementId, entitlementName } = record;
      const { serviceEntitlementApi } = this.props;
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: entitlementName,
        errorRollback: () => this.changeStatus(entitlementId, !status),
      });
      if (status) {
        serviceEntitlementApi.activateServiceEntitlement(
          entitlementId,
          callback
        );
      } else {
        serviceEntitlementApi.inActivateServiceEntitlement(
          entitlementId,
          callback
        );
      }
      this.changeStatus(entitlementId, status);
    } catch (error) {
      message.error(`Error changing status of ${record.entitlementName}`);
    }
  };

  changeStatus = (entitlementId, status) => {
    const serviceEntitlementData = (
      this.state.serviceEntitlementData || []
    ).map((obj) => obj);
    serviceEntitlementData.forEach((item) => {
      if (item.entitlementId === entitlementId) {
        item.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
        return;
      }
    });
    this.setState({ serviceEntitlementData });
  };

  render() {
    const { serviceProviderRecord, onParentActionClick } = this.props;
    const {
      action,
      record,
      serviceEntitlementData,
      serviceEntitlementDataLoading,
    } = this.state;
    return (
      <div className="service-entitlement-container">
        {!action ? (
          <ListServiceEntitlement
            serviceProviderRecord={serviceProviderRecord}
            serviceEntitlementData={serviceEntitlementData}
            serviceEntitlementDataLoading={serviceEntitlementDataLoading}
            onActionClick={this.onActionClick}
            onParentActionClick={onParentActionClick}
            onStatusChange={this.onStatusChange}
            parentBread={this.header}
          />
        ) : (
          <ServiceEntitlementForm
            serviceProviderRecord={serviceProviderRecord}
            action={action}
            record={record}
            onSubmit={this.onSubmit}
            onActionClick={this.onActionClick}
            parentBread={this.header}
          />
        )}
      </div>
    );
  }
}

ServiceEntitlement.propTypes = {
  serviceProviderRecord: PropTypes.object,
  onParentActionClick: PropTypes.func,
  serviceEntitlementApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  serviceEntitlementApi: state.apis.serviceEntitlementApi,
});
const connectedServiceEntitlement =
  connect(mapStateToProps)(ServiceEntitlement);
export default withRouter(connectedServiceEntitlement);
